<div class="container pt-4">
  <div class="card shadow-lg p-4">
    <h4 class="small mb-4" style="font-family: GartnerSans;">INVENTORY REPORTS (AWS)</h4>
    <p style="color: #002869;">
      View and download the latest AWS inventory reports.
    </p>

    <div *ngIf="error" class="alert alert-danger" style="font-family: GartnerSans;">{{ error }}</div>

    <div class="form-floating-sm">
  <input 
    type="text" 
    class="form-control"
    style="font-family: GartnerSans;"
    id="filterInput" 
    placeholder="Search" 
    (input)="applyFilter($event)"
  >
  <br>
</div>

<!-- Loading Bar -->
<div *ngIf="showProgress" class="text-center">
  <!-- <img src="assets/loading.gif"> -->
  <img src="assets/loader.gif" class="loading-gif">
</div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-100 table table-striped table-hover align-middle">

        <!-- Filename Column -->
        <ng-container matColumnDef="filename">
          <th mat-header-cell *matHeaderCellDef aria-sort="ascending" class="text-uppercase medium fw-semibold px-3 py-2" style="font-family: GartnerSans;">File Name</th>
          <td mat-cell *matCellDef="let data" class="small px-3 py-2" style="font-family: GartnerSans;">{{ data.file_name_with_ext }}</td>
        </ng-container>

        <!-- Size Column -->
        <ng-container matColumnDef="filesize">
          <th mat-header-cell *matHeaderCellDef class="text-uppercase medium fw-semibold px-3 py-2" style="font-family: GartnerSans;">Size</th>
          <td mat-cell *matCellDef="let data" class="small px-3 py-2" style="font-family: GartnerSans;">{{ formatBytes(data.filesize) }}</td>
        </ng-container>

        <!-- Modified Date Column -->
        <ng-container matColumnDef="modified_date">
          <th mat-header-cell *matHeaderCellDef class="text-uppercase medium fw-semibold px-3 py-2" style="font-family: GartnerSans;">Last Modified</th>
          <td mat-cell *matCellDef="let data" class="small px-3 py-2" style="font-family: GartnerSans;">{{ data.modified_date | date:'medium' }}</td>
        </ng-container>

        <!-- View Column -->
        <ng-container matColumnDef="view">
          <th mat-header-cell *matHeaderCellDef class="text-uppercase medium fw-semibold px-3 py-2" style="font-family: GartnerSans;">View</th>
          <td mat-cell *matCellDef="let data" class="small px-3 py-2" style="font-family: GartnerSans;">
            <a [routerLink]="['/viewfile', data.folder_name, data.file_name_without_ext]"><img src="assets/icon-eye.svg" style="width:25px;height:25px"></a>
          </td>
        </ng-container>

        <!-- Download Column -->
        <ng-container matColumnDef="download">
          <th mat-header-cell *matHeaderCellDef class="text-uppercase medium fw-semibold px-3 py-2" style="font-family: GartnerSans;">Download</th>
          <td mat-cell *matCellDef="let data" class="small px-3 py-2" sstyle="font-family: GartnerSans;">
            <a (click)="downloadFile(data)" style="cursor: pointer;">
              <img src="assets/icon-download.svg" style="width: 25px; height: 25px;" alt="Download">
            </a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <br>
    </div>

    <mat-paginator [pageSize]="25" [pageSizeOptions]="[5, 10, 20, 25]" showFirstLastButtons></mat-paginator>
  </div>
</div>